package com.tixforgigs.common.core.extensions

import io.github.oshai.kotlinlogging.KotlinLogging
import io.github.oshai.kotlinlogging.logger
import kotlinx.serialization.json.Json

inline fun <reified T> T.toJsObject(): kotlin.js.Json {

  val log by KotlinLogging.logger()

  val jsonString = runCatching {
    Json.encodeToString(this)
  }.onFailure {
    log.debug { "Error serializing object ${T::class} to Json: $it" }
  }.getOrDefault("")
  return JSON.parse(jsonString)
}

inline fun <reified T> List<T>.toJsObjectArray(): Array<kotlin.js.Json> {
  return this.map { it.toJsObject() }.toTypedArray()
}

fun Double.format(digits: Int): String = this.asDynamic().toFixed(digits)
fun Float.format(digits: Int): String = this.asDynamic().toFixed(digits)
